import React from 'react';

const DataItem = ({ category, items, color }) => (
  <div
    style={{
      background: 'rgba(255,255,255,0.02)',
      border: `1px solid ${color}22`,
      borderLeft: `3px solid ${color}`,
      padding: '20px 24px',
      marginBottom: '16px'
    }}
  >
    <div
      style={{
        fontFamily: 'Syne, sans-serif',
        fontSize: '0.75rem',
        fontWeight: 700,
        color: color,
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        marginBottom: '12px'
      }}
    >
      {category}
    </div>
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
      {items?.map((item, i) => (
        <span
          key={i}
          style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '0.8125rem',
            color: 'rgba(238,240,242,0.75)',
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(255,255,255,0.08)',
            padding: '4px 10px'
          }}
        >
          {item}
        </span>
      ))}
    </div>
  </div>
);

const DataCollectionSection = () => {
  return (
    <section id="innsamling" style={{ marginBottom: '80px' }}>
      {/* Section header */}
      <div style={{ marginBottom: '40px', position: 'relative' }}>
        <div
          style={{
            fontFamily: 'Impact, sans-serif',
            fontSize: 'clamp(4rem, 10vw, 8rem)',
            fontWeight: 900,
            color: 'rgba(59,111,212,0.06)',
            lineHeight: 1,
            position: 'absolute',
            top: '-20px',
            left: '-10px',
            userSelect: 'none',
            letterSpacing: '-0.04em'
          }}
        >
          01
        </div>
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div
            style={{
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: '0.6875rem',
              color: '#F97316',
              letterSpacing: '0.15em',
              textTransform: 'uppercase',
              marginBottom: '8px'
            }}
          >
            § 1 — DATAINNSAMLING
          </div>
          <h2
            style={{
              fontFamily: 'Impact, sans-serif',
              fontSize: 'clamp(1.75rem, 4vw, 3rem)',
              fontWeight: 900,
              color: '#EEF0F2',
              textTransform: 'uppercase',
              letterSpacing: '-0.02em',
              lineHeight: 1
            }}
          >
            Hvilke data samler vi inn?
          </h2>
        </div>
      </div>

      <p
        style={{
          fontFamily: 'Georgia, serif',
          fontSize: '1.0625rem',
          color: 'rgba(238,240,242,0.7)',
          lineHeight: 1.8,
          marginBottom: '32px',
          maxWidth: '720px'
        }}
      >
        NordPass AS samler inn personopplysninger som er nødvendige for å levere våre tjenester 
        i henhold til GDPR artikkel 6(1)(b) — oppfyllelse av avtale. Vi samler kun inn data 
        som er strengt nødvendig for tjenestelevering.
      </p>

      <DataItem
        category="Identifikasjonsdata"
        color="#3B6FD4"
        items={['Fullt navn', 'E-postadresse', 'Telefonnummer', 'Fødselsdato', 'Nasjonalitet']}
      />
      <DataItem
        category="Adressedata"
        color="#F97316"
        items={['Gateadresse', 'Postnummer', 'By/Sted', 'Fylke', 'Land']}
      />
      <DataItem
        category="Kjøretøydata"
        color="#10B981"
        items={['Registreringsnummer', 'Kjøretøytype', 'Drivstofftype', 'Vekt/Akselkonfigurasjon', 'AutoPASS-brikke ID', 'Kjøretøyhistorikk']}
      />
      <DataItem
        category="Bruksdata & Analytikk"
        color="#8B5CF6"
        items={['IP-adresse', 'Nettlesertype', 'Enhetsidentifikator', 'Rutehistorikk', 'Søkehistorikk', 'Klikkmønstre', 'Sesjonsvarighet']}
      />
      <DataItem
        category="Betalingsdata"
        color="#EF4444"
        items={['Faktureringsadresse', 'Betalingsmetode (tokenisert)', 'Transaksjonshistorikk', 'Abonnementsstatus']}
      />

      <div
        style={{
          background: 'rgba(59,111,212,0.06)',
          border: '1px solid rgba(59,111,212,0.2)',
          padding: '20px 24px',
          marginTop: '24px'
        }}
      >
        <p
          style={{
            fontFamily: 'Georgia, serif',
            fontStyle: 'italic',
            fontSize: '0.9375rem',
            color: 'rgba(238,240,242,0.6)',
            lineHeight: 1.7,
            margin: 0
          }}
        >
          <strong style={{ color: '#3B6FD4', fontStyle: 'normal' }}>Rettslig grunnlag:</strong>{' '}
          Behandlingen er basert på GDPR art. 6(1)(a) samtykke, art. 6(1)(b) kontraktsoppfyllelse, 
          og art. 6(1)(f) berettiget interesse for analytiske formål.{' '}
          <a
            href="/terms-conditions-vilk-r-betingelser#abonnement"
            style={{ color: '#F97316', textDecoration: 'underline', textDecorationColor: 'rgba(249,115,22,0.4)', fontStyle: 'normal' }}
          >
            Se våre Vilkår & Betingelser for abonnementsdetaljer →
          </a>
        </p>
      </div>
    </section>
  );
};

export default DataCollectionSection;
